import { Component, Inject, Input, OnDestroy, OnInit, inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBar, MatSnackBarRef, MatSnackBarModule } from '@angular/material/snack-bar';
import { NgIf } from '@angular/common';
import { Subscription, timer } from 'rxjs';

@Component({
    selector: 'app-snack-bar',
    templateUrl: './snack-bar.component.html',
    styleUrls: ['./snack-bar.component.scss'],
    standalone: true,
    imports: [MatSnackBarModule, NgIf]
})
export class SnackBarComponent implements OnInit, OnDestroy {

  message: string = '';
  actionType: 'login' | undefined;
  snackBarRef = inject(MatSnackBarRef);
  timerSub: Subscription | undefined;

  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: any) {}

  ngOnInit(): void {
    this.message = this.data.message;
    this.actionType = this.data.actionType;

    this.timerSub = timer(5000).subscribe(() => {
      this.snackBarRef.dismissWithAction();
    })
  }

  ngOnDestroy() {
    this.timerSub?.unsubscribe();
  }
}
